import actionTypes from '../actions/actionTypes'

const informationReducer = (state = {lastId: 0, array: []}, action) => {
	switch (action.type) {
		case actionTypes.OPEN_CENTER_INFORMATION: {
			const uid = state.lastId+1
			return {
				lastId: uid,
				array: [...state.array, {...action.messageObject, uid}],
			}
		}
		case actionTypes.CLOSE_CENTER_INFORMATION: {
			const index = state.array.findIndex(information => information.uid === action.uid)
			if (index !== -1) {
				return {
					lastId: state.lastId,
					array: [...state.array.slice(0, index), ...state.array.slice(index + 1)],
				}
			} else {
				return state
			}
		}
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_SUCCESS: {
			const uid = state.lastId+1
			return {
				lastId: uid,
				array: [...state.array, {message: 'Added', uid}],
			}
		}
		case actionTypes.SEND_FORM_POST: {
			const uid = state.lastId+1
			return {
				lastId: uid,
				array: [...state.array, {message: 'Sent', uid}],
			}
		}
		default:
			return state
	}
}

export default informationReducer
